import styles from './footer.module.scss';

export const Footer = () => {
  return <section className={styles.footer}>
    <p>© TOPORGARAGE {new Date().getFullYear()} </p>
    <p> Design&create by <a target="_blank" rel="noreferrer" href={"https://www.linkedin.com/in/patrycja-handziuk/"}>Patrycja
      Hańdziuk</a></p>
  </section>
}